import validationRules from "../validationRules";
import { parseDatetimeDefault, parseRelativeDate, } from "@/components/forms/components/utils";
validationRules.register("mandatory", function (record, fieldMetadataMap, fieldName, t) {
    var _a, _b, _c;
    var defaultValue = fieldMetadataMap === null || fieldMetadataMap === void 0 ? void 0 : fieldMetadataMap.get(fieldName).default;
    //Champs type relate and parent
    var idFieldName = (_a = fieldMetadataMap === null || fieldMetadataMap === void 0 ? void 0 : fieldMetadataMap.get(fieldName)) === null || _a === void 0 ? void 0 : _a.id_name;
    // debut de traitement des champs date et datetime
    if ((fieldMetadataMap === null || fieldMetadataMap === void 0 ? void 0 : fieldMetadataMap.get(fieldName).dbType) === "datetime") {
        defaultValue = new Date(parseDatetimeDefault((_b = fieldMetadataMap === null || fieldMetadataMap === void 0 ? void 0 : fieldMetadataMap.get(fieldName)) === null || _b === void 0 ? void 0 : _b.display_default));
    }
    if ((fieldMetadataMap === null || fieldMetadataMap === void 0 ? void 0 : fieldMetadataMap.get(fieldName).dbType) === "date") {
        defaultValue = new Date(parseRelativeDate((_c = fieldMetadataMap === null || fieldMetadataMap === void 0 ? void 0 : fieldMetadataMap.get(fieldName)) === null || _c === void 0 ? void 0 : _c.display_default));
    }
    //fin de traitement date et datetime
    var value = "";
    if (!idFieldName) {
        if (fieldName === "filename") {
            value = record["document_name"];
        }
        else {
            value = record[fieldName || ""] || defaultValue;
        }
    }
    else {
        value = record[idFieldName || ""];
    }
    if (value) {
        return true;
    }
    else {
        //logger.log("fieldname: ", fieldName);
        return "is required.";
    }
});
